export default "__VITE_ASSET__BglWnLB4__"